import { TranslationObject } from 'ontime-types';

export const langDe: TranslationObject = {
  'common.expected_finish': 'Erwartetes Ende',
  'common.minutes': 'min',
  'common.seconds': 'sek',
  'common.now': 'Jetzt',
  'common.next': 'Nächste',
  'common.scheduled_start': 'Geplanter beginn',
  'common.scheduled_end': 'Geplantes ende',
  'common.expected_start': 'Erwartetes beginn',
  'common.expected_end': 'Erwartetes ende',
  'common.timer_message': 'Timer-Nachricht',
  'common.secondary_message': 'Sekundär-Nachricht',
  'common.stage_timer': 'Bühnen-Timer',
  'common.started_at': 'Gestartet am',
  'common.time_now': 'Aktuelle Zeit',
  'common.no_data': 'Keine Daten',
  'countdown.ended': 'Veranstaltung endete um',
  'countdown.running': 'Veranstaltung läuft',
  'countdown.loaded': 'Veranstaltung geladen',
  'countdown.select_event': 'Wählen Sie eine Veranstaltung aus, um sie zu verfolgen',
  'countdown.to_start': 'Zeit bis zum Start',
  'countdown.waiting': 'Warten auf den Veranstaltungsbeginn',
  'countdown.overtime': 'überfällig',
  'countdown.all_have_finished': 'Alle ausgewählten Veranstaltungen sind beendet',
  'timeline.live': 'live',
  'timeline.done': 'Beendet',
  'timeline.due': 'fällig',
  'timeline.followedby': 'Gefolgt von',
  'project.title': 'Titel',
  'project.description': 'Beschreibung',
  'project.info': 'Projektinfo',
  'project.url': 'Projekt-URL',
};
